import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup";
import Select from 'react-select';
import client from '../../../lib/feathers';
import getVintages from '../../../utilities/getVintages';

const schema = yup.object({
  name: yup.string().required("Please enter a name for this wine"),
  vintage: yup.string().required("Please enter a vintage for this wine"),
}).required();

export default function NewLibationForm(props) {
  const { onCancelClick } = props;
  const { lid } = useParams();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);

  const vintageList = getVintages();

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })

  const navigateToWine = (libation) => {
    navigate(`/${user.role}/listings/${lid}/wines/${libation.id}/edit`);
  }

  const onSubmit = async (values) => {
    if (user) {
      const service = client.service(`${user.role}/libation`);
      const data = {
        ...values,
        needsReview: false,
        listingId: lid,
      };
      try {
        const result = await service.create(data);
        navigateToWine(result);
      } catch (e) {
        console.log('Error creating new Wine: ', e);
      }
    }
  };

  // Tailwind Styles //
  const errorFocus = 'border-red-400 focus:border-red-500 focus:ring-red-500';
  const nonErrorFocus = 'border-gray-300 focus:ring-gray-500 focus:border-gray-500';

  return (
    <>
      <div className="mt-3 text-center sm:mt-5">
        <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
          Create New Wine
        </h3>
        <div className="mt-2">
          <p className="text-sm text-gray-500">
            Enter the name for this wine.
          </p>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="text-left">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                Name
              </label>
              <div className="mt-1">
                <input
                  id="name"
                  placeholder="Wine name"
                  {...register("name")}
                  className={`appearance-none block w-full px-3 py-2 border ${errors.name ? errorFocus : nonErrorFocus} rounded-md shadow-sm placeholder-gray-400 focus:outline-none sm:text-sm`}
                />
                {errors.name && <span className="text-red-400">{errors.name.message}</span>}

              </div>
            </div>

            <div className="col-span-6 sm:col-span-3 text-left my-5">
              <label htmlFor="vintage" className="block text-sm font-medium text-gray-700">
                Vintage
              </label>
              <Controller
                name="vintage"
                control={control}
                render={({ field: { onChange, value, ref } }) => (
                  <Select
                    ref={ref}
                    options={vintageList}
                    onChange={(val) => onChange(val.value)}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        borderColor: errors.vintage ? 'red' : '#CCCCCC',
                      }),
                    }}
                    className="shadow-sm"
                  />
                )}
              />
              {errors.vintage && <span className="text-red-400">{errors.vintage.message}</span>}
            </div>

            <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
              <button type="submit" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-icon text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 hover:bg-red-700 sm:col-start-2 sm:text-sm">Create</button>
              <button type="button" onClick={onCancelClick} className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:col-start-1 sm:text-sm">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
};
